import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseConfigService } from '@fuse/services/config.service';

import { SidebarDetailHostDirective, SidebarDetailService } from '@appshared';

@Component({
    selector     : 'vertical-layout-1',
    templateUrl  : './layout-1.component.html',
    styleUrls    : ['./layout-1.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class VerticalLayout1Component implements OnInit, OnDestroy, AfterViewInit
{
    fuseConfig: any;

    // Private
    private _unsubscribeAll: Subject<any>;

    
    @ViewChild(SidebarDetailHostDirective) sidebarDetailHostEle!: SidebarDetailHostDirective;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _sidebarDetailService: SidebarDetailService,
    )
    {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    ngAfterViewInit(): void {
        this._sidebarDetailService.setHostEle(this.sidebarDetailHostEle);
    }

    openedSidebarPanel(): boolean {
        return this._sidebarDetailService.isOpenView();
    }

    closeSidebarPanel(): void {
        this._sidebarDetailService.closeView();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Subscribe to config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.fuseConfig = config;
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
